import { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "../common";

export const Question3 = ({
  updateQuestion,
  jurisdiction,
  answer,
  updateAnswer,
}) => {
  const [blockContinue, setBlockContinue] = useState(() => {
    return jurisdiction === "nhs" ? false : true;
  });
  const [searchText, setSearchText] = useState(answer?.searchText || "");
  const [searchInputValue, setSearchInputValue] = useState(
    answer?.searchInputValue || ""
  );
  const [organisationInputValue, setOrganisationInputValue] = useState(
    answer?.organisationInputValue || ""
  );
  const [showLookupOrg, setShowLookupOrg] = useState(
    answer?.showLookupOrg || false
  );

  // Helper to persist answer changes
  const saveAnswer = (updates) => {
    updateAnswer({
      searchText: updates.searchText ?? searchText,
      searchInputValue: updates.searchInputValue ?? searchInputValue,
      organisationInputValue:
        updates.organisationInputValue ?? organisationInputValue,
      showLookupOrg: updates.showLookupOrg ?? showLookupOrg,
    });
  };

  useEffect(() => {
    if (jurisdiction === "nhs") {
      setBlockContinue(false);
    }
  }, [jurisdiction]);

  return (
    <div className="question-card">
      <div className="question-card__content">
        <h2 className="question-card__title">Name of the organisation</h2>
        <span className="question-card__required">*Required</span>

        {jurisdiction === "parliamentary" && (
          <>
            {showLookupOrg ? (
              <p>
                <input
                  value={organisationInputValue}
                  className="field"
                  placeholder="Name of organisation"
                  onChange={(e) => {
                    setOrganisationInputValue(e.target.value);
                    saveAnswer({ organisationInputValue: e.target.value });
                  }}
                />
              </p>
            ) : (
              <>
                <p style={{ marginTop: "16px" }}>
                  Please enter one or two keywords to describe your complaint.
                  For example you could enter 'Passport' for Passport Office
                  related complaints or 'Driving License' for DVLA complaints:
                </p>
                <Fragment>
                  <input
                    type="text"
                    className="field mt-3"
                    value={searchInputValue}
                    placeholder="Enter one or two keywords"
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        setSearchText(e.target.value);
                        saveAnswer({ searchText: e.target.value });
                      }
                    }}
                    onChange={(e) => {
                      setSearchInputValue(e.target.value);
                      saveAnswer({ searchInputValue: e.target.value });
                    }}
                  />
                  {searchText.length >= 3 ? null : <></>}
                </Fragment>
                <button
                  className="link mt-2"
                  onClick={() => {
                    setShowLookupOrg(true);
                    saveAnswer({ showLookupOrg: true });
                  }}
                >
                  Click here if you can't find the organisation you would like
                  to complain about
                </button>
              </>
            )}
          </>
        )}

        {jurisdiction === "nhs" && <p style={{ marginTop: "16px" }}>NHS</p>}
      </div>

      <div className="question-card__actions">
        <Button variant="previous" onClick={() => updateQuestion(2)}>
          Previous question
        </Button>
        <Button
          variant="continuation"
          onClick={() =>
            jurisdiction === "nhs" ? updateQuestion(4) : updateQuestion(5)
          }
          disabled={blockContinue}
        >
          Next question
        </Button>
      </div>
    </div>
  );
};

Question3.propTypes = {
  updateQuestion: PropTypes.func,
  jurisdiction: PropTypes.string,
  answer: PropTypes.object,
  updateAnswer: PropTypes.func,
};
